<script setup>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import { isPhoneE164 } from 'shared/helpers/Validators';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const state = reactive({ name: '', phoneNumber: '' });
const uiFlags = useMapGetter('inboxes/getUIFlags');
const v$ = useVuelidate(
  { name: { required }, phoneNumber: { required, isPhoneE164 } },
  state
);

async function createChannel() {
  if (!(await v$.value.$validate())) return;
  try {
    const channel = await store.dispatch('inboxes/createZadarmaChannel', {
      name: state.name,
      zadarma: { phone_number: state.phoneNumber },
    });
    router.replace({
      name: 'settings_inboxes_add_agents',
      params: { page: 'new', inbox_id: channel.id },
    });
  } catch (error) {
    useAlert(
      error.response?.data?.message ||
        t('INBOX_MGMT.ADD.ZADARMA.API.ERROR_MESSAGE')
    );
  }
}
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full">
    <PageHeader
      :header-title="t('INBOX_MGMT.ADD.ZADARMA.TITLE')"
      :header-content="t('INBOX_MGMT.ADD.ZADARMA.DESCRIPTION')"
    />
    <form class="flex flex-col gap-4" @submit.prevent="createChannel">
      <Input
        v-model="state.name"
        :label="t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL')"
        @blur="v$.name.$touch"
      />
      <Input
        v-model="state.phoneNumber"
        :label="t('INBOX_MGMT.ADD.ZADARMA.PHONE_NUMBER.LABEL')"
        :placeholder="t('INBOX_MGMT.ADD.ZADARMA.PHONE_NUMBER.PLACEHOLDER')"
        :message="
          v$.phoneNumber.$error
            ? t('INBOX_MGMT.ADD.ZADARMA.PHONE_NUMBER.ERROR')
            : ''
        "
        @blur="v$.phoneNumber.$touch"
      />
      <NextButton
        :is-loading="uiFlags.isCreating"
        :disabled="v$.$invalid"
        :label="t('INBOX_MGMT.ADD.ZADARMA.SUBMIT_BUTTON')"
        type="submit"
      />
    </form>
  </div>
</template>
